export const MEDIA_TYPE_VIDEO = 'VIDEO';
export const MEDIA_TYPE_IMAGE = 'IMAGE';
export const MEDIA_TYPE_WEBSITE = 'WEBSITE';
export const MEDIA_TYPE_PLAYLIST = 'PLAYLIST';
export const MEDIA_TYPE_CAIXA_LOTTERY = 'CAIXA_BR_LOTTERY';
export const MEDIA_TYPE_INSTAGRAM = 'INSTAGRAM';
export const MEDIA_TYPE_FACEBOOK = 'FACEBOOK';
export const MEDIA_TYPE_TWITTER = 'TWITTER';
export const MEDIA_TYPE_YOUTUBE = 'YOUTUBE';
export const MEDIA_TYPE_BR_CITTAMOBI = 'BR_CITAMOBI';